import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { TileService } from '../tile/tile.service';
import { Contact, Tile } from '../tile/tile';
import { map } from 'rxjs/operators';
import { BreadcrumbService } from '../library/breadcrumb.service';
import { TrackingContactUsService } from '../tracking/tracking-contact-us.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent implements OnInit {
  tilesTree: Observable<Tile[]>;
  tilesLevel1: Observable<Tile[]>;
  tilesLevel2: Observable<Tile[]>;
  tilesLevel3: Observable<Tile[]>;
  tilesLevel4: Observable<Tile[]>;
  parentRoute1: string;
  parentRoute2: string;
  parentRoute3: string;
  parentRoute4: string;
  tilesTitle: string[];
  contacts: Observable<Contact[]>;
  segment2: UrlSegment;

  private contactUsTypes = ['public', 'pme', 'propme', 'gc', 'fortest'];

  constructor(
    private route: ActivatedRoute,
    private service: TileService,
    private breadcrumbService: BreadcrumbService,
    private trackingContactUsService: TrackingContactUsService
  ) {}

  ngOnInit(): void {
    this.parentRoute1 = '/';
    this.parentRoute2 = '';
    this.parentRoute3 = '';
    this.parentRoute4 = '';

    this.route.url.subscribe((urlSegment) => {
      this.tilesLevel1 = of([]);
      this.tilesLevel2 = of([]);
      this.tilesLevel3 = of([]);
      this.tilesLevel4 = of([]);
      this.tilesTitle = [];
      this.segment2 = null;

      if (urlSegment.length > 0) {
        const contactUsType = urlSegment[0].path;
        // TODO to be refactored passing contactType in service
        if (this.contactUsTypes.indexOf(contactUsType) !== -1) {
          this.breadcrumbService.setBreadcrumbElements([
            {
              label: 'Nous Contacter',
              link: '/contact-us/' + contactUsType,
            },
          ]);

          this.trackingContactUsService.trackViewHome();

          this.tilesTree = this.service.loadTiles(contactUsType);
          this.tilesLevel1 = this.tilesTree.pipe(map((tiles) => tiles.filter((tile) => tile.level === 1)));

          let parentRoute = '/';
          urlSegment.forEach((segment, index) => {
            parentRoute += segment.path + '/';

            if (index > 0) {
              this.generateTilesTitle(segment);
            }

            if (index === 0) {
              this.parentRoute1 = parentRoute;
            }

            if (index === 1) {
              this.parentRoute2 = parentRoute;
              this.tilesLevel2 = this.getDaughtersTilesByParentSlug(segment);
              this.segment2 = segment;
            }

            if (index === 2) {
              this.parentRoute3 = parentRoute;
              this.tilesLevel3 = this.getDaughtersTilesByParentSlug(segment);
            }

            if (index === 3) {
              this.parentRoute4 = parentRoute;
              this.tilesLevel4 = this.getDaughtersTilesByParentSlug(segment);
            }
          });
        }
      }
    });

    this.route.url.subscribe((urlSegment) => {
      this.contacts = of([]);

      if (urlSegment.length > 0) {
        const contactUsType = urlSegment[0].path;
        // TODO to be refactored passing contactType in service
        if (this.contactUsTypes.indexOf(contactUsType) !== -1) {
          this.contacts = this.tilesTree.pipe(
            map((tiles) => {
              if (urlSegment.length > 1) {
                const lastTile = tiles.filter((tile) => tile.slug === urlSegment[urlSegment.length - 1].path)[0];
                if (lastTile && lastTile.daughtersTilesSlug.length === 0) {
                  return lastTile.contacts;
                } else {
                  return [];
                }
              }
            })
          );
        }
      }
    });
  }

  private getDaughtersTilesByParentSlug(parentTilesSlug) {
    return this.tilesTree.pipe(
      map((tiles) => {
        const t = tiles.filter((tile) => tile.slug === parentTilesSlug.path);
        if (t && t.length > 0) {
          return tiles.filter((tile) => t[0].daughtersTilesSlug.includes(tile.slug));
        } else {
          return [];
        }
      })
    );
  }

  private generateTilesTitle(segment) {
    this.getTitleTileByTileSlug(segment).subscribe((title) => {
      this.tilesTitle.push(title);
    });
  }

  private getTitleTileByTileSlug(parentTilesSlug) {
    return this.tilesTree.pipe(
      map((tiles) => {
        const t = tiles.filter((tile) => tile.slug === parentTilesSlug.path);
        if (t && t.length > 0) {
          return t[0].title;
        } else {
          return '';
        }
      })
    );
  }
}
